<template lang="pug">
v-menu(v-model="menu" bottom :close-on-content-click="false")
    template(v-slot:activator="{ on }")
        v-btn(v-on="on" text :disabled="disabled" :class="btnClasses")
            slot(name="button")
                v-icon(:class="iconClasses" v-if="icon") {{ icon }}
                template(v-if="text") {{ text }}
    slot
        v-card
            v-card-text
                v-text-field(ref="field" :label='fieldLabel' v-model="field" @keyup.enter = "_change")
            v-card-actions.justify-end
                v-btn(text color='primary' @click="_change") ok
</template>

<script>
export default {
  props: {
    btnClasses: Array,
    iconClasses: Array,
    disabled: Boolean,
    icon: String,
    text: String,
    fieldLabel: String
  },

  data: () => ({
    field: null,
    menu: false
  }),

  methods: {
    _change() {
      this.$emit('change', this.field)
      this.menu = false
      this._reset()
    },

    _reset() {
      this.field = null
    }
  },

  watch: {
    menu() {
      if(this.menu) setTimeout(() => {
        this.$refs.field.focus()
      }, 50)
    }
  }
}
</script>